// /src/renderer/layout/TopMenu/index.ts
import withNavigation from './withNavigation';
import TopMenu from './TopMenu';

export default withNavigation(TopMenu);
